import { useHotkeys, type HotkeyItem } from '@mantine/hooks'

interface StoryViewerHotkeyHandlers {
	enabled: boolean
	canPreviousPerson: boolean
	canNextPerson: boolean
	canPreviousStory: boolean
	canNextStory: boolean
	isVideo: boolean
	onClose: () => void
	onPreviousPerson: () => void
	onNextPerson: () => void
	onPreviousStory: () => void
	onNextStory: () => void
	onTogglePlayback?: () => void
}

export default function useStoryViewerHotkeys({
	enabled,
	canPreviousPerson,
	canNextPerson,
	canPreviousStory,
	canNextStory,
	isVideo,
	onClose,
	onPreviousPerson,
	onNextPerson,
	onPreviousStory,
	onNextStory,
	onTogglePlayback,
}: StoryViewerHotkeyHandlers) {
	const hotkeys: HotkeyItem[] = []

	if (enabled) {
		if (canPreviousPerson) hotkeys.push(['ArrowLeft', onPreviousPerson])
		if (canNextPerson) hotkeys.push(['ArrowRight', onNextPerson])
		if (canPreviousStory) hotkeys.push(['ArrowUp', onPreviousStory])
		if (canNextStory) hotkeys.push(['ArrowDown', onNextStory])
		hotkeys.push(['Escape', onClose])
		if (isVideo && onTogglePlayback) hotkeys.push(['Space', onTogglePlayback])
	}

	useHotkeys(hotkeys)
}
